import React, { useEffect, useState } from 'react'
import { Breadcrumb, Card } from 'react-bootstrap';
import { Link, useParams, useHistory, useLocation } from 'react-router-dom'
import { CompanyService } from '@services/company.service';
import { useDispatch } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { fetchAndSetCompany } from 'src/effects/company.effects';
import { claimTemplateService } from '@services/claim_template.service';
import questionnairesService from '@services/questionnaires.service';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import SidebarPortal from '@rd-web-markets/shared/dist/util/SidebarPortal';
import { useTranslation } from 'react-i18next';
import { CompanyEditPageContent } from '@rd-web-markets/market/dist/company';
import CompanyMarketRelatedFields from '@rd-web-markets/market/dist/company/CompanyMarketRelatedFields';
import ClaimGroupSidebar from '@rd-web-markets/shared/dist/pages/setup/ClaimGroupSidebar';
import { claimGroupMenuItemsCreator } from '@rd-web-markets/market/dist/company/claimGroupMenuItemsCreator';
import CompanyV2Header from './v2/CompanyV2Header';
import { USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';
import { setBreadcrumb, clearBreadcrumb } from '@rd-web-markets/shared/dist/store/features/navbarBreadcrumbSlice';

const CompanyEditPage = ({accountType, handleToaster}) => {
  let { id } = useParams();
  const dispatch = useDispatch();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);
  const [claimTemplates, setClaimTemplates] = useState([]);
  const { t } = useTranslation();

  const [questionnaires] = questionnairesService.useQuestionnaires();

  useEffect(() => {
    fetchAndSetCompany(id, setCompany, dispatch, handleError);
    claimTemplateService.get()
      .then(setClaimTemplates)
      .catch(error => dispatch(handleError(error)));
  }, [id, dispatch]);

  useEffect(() => {
    if (company) {
        dispatch(setBreadcrumb({
          label: company.name,
          path: `/${accountType}/companies/${company.id}/overview`
        }));
      }
      return () => dispatch(clearBreadcrumb());
    }, [company?.id, accountType, dispatch]);

  if (!company || !questionnaires) return <div>Loading</div>;

  const handleSubmit = async company => {
    setLoading(true);
    company.claims_attributes = company.claims;
    try {
      await CompanyService.update(company);
      setLoading(false);
    } catch(error) {
      dispatch(handleError(error));
      setLoading(false);
    }
  };

  return (
    <>
      {!USE_V2_DESIGN && (
        process.env.PUBLIC_URL === '/de'
          ? <ClaimGroupSidebar
              claimGroup={company.claim_groups[0]}
              company={company}
              claims={company.claims}
              accountType={accountType}
              highlightedMenuItem='de/edit_company_info'
              customMenuItems={claimGroupMenuItemsCreator({ company, allClaimGroups: company.claim_groups })}
            />
          : <SidebarPortal headerItem={{ link: `companies/${company.id}/master`, text: company.name }} />
      )}

      {!USE_V2_DESIGN && (
        <BreadcrumbsPortal>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${accountType}`}}>{t('home')}</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${accountType}/companies`}}>{t('companies')}</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: `/${accountType}/companies/${company.id}/master`}}>{company.name}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('edit')}</Breadcrumb.Item>
          </Breadcrumb>
        </BreadcrumbsPortal>
      )}

      {USE_V2_DESIGN && (
        <CompanyV2Header company={company} accountType={accountType} activeTab="settings" />
      )}

      <div style={USE_V2_DESIGN ? { maxWidth: '95%', margin: '0 auto', padding: '1.5rem 3rem 2rem' } : {}}>
        <CompanyEditPageContent
          claimTemplates={claimTemplates}
          company={company}
          setCompany={setCompany}
          handleSubmit={handleSubmit}
          loading={loading}
          handleToaster={handleToaster}
          setLoading={setLoading}
          questionnaires={questionnaires}
          CompanyMarketRelatedFields={CompanyMarketRelatedFields}
          isV2={USE_V2_DESIGN}
        />
      </div>
    </>
  );
};

export default CompanyEditPage;
